import { dispatchPointerEvent } from '../utils/events.es.js';
var mouseEvent = function mouseEvent(element, name, action) {
  return function (event) {
    if (event.pointerType && event.pointerType !== "mouse") return;
    action();
    dispatchPointerEvent(element, name, event);
  };
};
var hover = {
  isActive: function isActive(options) {
    return Boolean(options.hover);
  },
  subscribe: function subscribe(element, _ref) {
    var enable = _ref.enable,
      disable = _ref.disable;
    var onEnter = mouseEvent(element, "hoverstart", enable);
    var onLeave = mouseEvent(element, "hoverend", disable);
    element.addEventListener("pointerenter", onEnter);
    element.addEventListener("pointerleave", onLeave);
    return function () {
      element.removeEventListener("pointerenter", onEnter);
      element.removeEventListener("pointerleave", onLeave);
    };
  }
};
export { hover };